import React, { ReactNode } from "react"
import { LinkToStacked, PageIndexProvider, StackedPageState, useStackedPage } from "react-stacked-pages-hook"

import close from "../assets/icons/close.svg"
import link from "../assets/icons/link.svg"
import "./note-wrapper.css"
import styled, { CSSObject } from "styled-components"
import { withPrefix } from "gatsby"

const SvgButton = styled.img`
width: 24px;
height: 24px;
cursor: pointer;
filter: invert(50%)
`
const Div = styled.div``
const Button = styled.button`
background: unset;
border: unset;
padding: 0;
`

const closeNoteButtonClass = "close-note-button"
const noteContainerClassName = ({ overlay, obstructed, highlighted }: StackedPageState = {}) =>
  `note-container ${overlay ? "note-container-overlay" : ""} ${
    obstructed ? "note-container-obstructed" : ""
  } ${highlighted ? "note-container-highlighted" : ""}`

const writePageUrlToClipboard = (slug: string) =>
  window.navigator.clipboard.writeText(window.location.origin + withPrefix(slug))

interface NoteWrapperProps {
  children: ReactNode
  slug: string
  title: string
}

const CopyButton = ({ slug }: { slug: string }) =>
  <Button
    css={{
      lineHeight: 0,
      borderRadius: "4px",
      "&:active": {
        backgroundColor: "#cff4cf",
      },
    }}
  >
    <SvgButton
      src={link}
      className={"copy-note-link-button"}
      onClick={() => writePageUrlToClipboard(slug)}
    />
  </Button>

const NoteWrapper = ({ children, slug, title }: NoteWrapperProps) => {
  const [, state, noteIndex, , , closePage] = useStackedPage()

  function CloseButton() {
    return noteIndex ?
      <SvgButton
        src={close}
        className={closeNoteButtonClass}
        onClick={closePage}
      /> : <></>
  }

  return (
    <Div
      className={noteContainerClassName(state)}
      css={{
        left: 40 * (noteIndex || 0),
        right: -585,
        position: "sticky",
      }}
    >
      <Div css={style.controlButtons}>

        <CopyButton slug={slug} />
        <CloseButton />
      </Div>

      <div className="note-content">{children}</div>

      <div className="obstructed-note-label">
        <CloseButton />
        <LinkToStacked to={slug} className="obstructed-label">
          {title}
        </LinkToStacked>
      </div>
    </Div>
  )
}

const ContextProvider = ({ i, ...rest }) => (
  <PageIndexProvider value={i}>
    <NoteWrapper {...rest} />
  </PageIndexProvider>
)

export default ContextProvider

const mobileScreenQuery = "@media screen and (max-width: 800px)"

const style = {
  controlButtons: {
    position: "absolute",
    top: "1em",
    right: "1em",
    display: "flex",
    [mobileScreenQuery]: {
      top: "0.5em",

      [`.${closeNoteButtonClass}`]: {
        display: "none"
      }
    },
  } as CSSObject,
}
